import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Element from '@fulcrumapp/fulcrum-core';
import { LiteElement } from '../../tasks/types';

interface Props{
  sections: Array<Element | LiteElement>;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && (
        <Box sx={{ padding: '0px 0px 24px 0px' }}>
          <Typography component="span" data-testid="tabpanel-child">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

const getLabels = (sections: Array<Element | LiteElement>) => {
  const labels: Array<Element | LiteElement> = [];

  sections.forEach((element) => {
    // @ts-ignore
    labels.push(<Tab label={element.label} key={element.key} />);
  });

  return labels;
};

function TabbedSectionGroup(props: Props) {
  const { sections } = props;
  const [selectedTab, setSelectedTab] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <Tabs value={selectedTab} onChange={handleChange}>
        {getLabels(sections)}
      </Tabs>
      {sections.map((element, index) => (
        // @ts-ignore
        <TabPanel index={index} value={selectedTab} key={element.key}>
          {/* @ts-ignore */}
          {element.elements.map((ele: Element | LiteElement) => <Box key={ele.key}>{ele}</Box>)}
        </TabPanel>
      ))}
    </>
  );
}

export default TabbedSectionGroup;
